import { api, setSessionToken } from './client';

// Types
export interface LoginResponse {
    ok: boolean;
}

export interface RatingsResponse {
    ok: boolean;
    items: any[];
    totals: { total: number; rated: number; feedback: number };
}

export interface CreateCandidateParams {
    candidateName: string;
    candidateEmail: string;
    interviewDate?: string;
    interviewTime?: string;
}

export interface CreateCandidateResponse {
    ok: boolean;
    candidateId?: string;
    interviewLink?: string;
    emailSent?: boolean;
    error?: string;
}

export interface CandidatesResponse {
    ok: boolean;
    candidates: Candidate[];
}

export interface Candidate {
    candidateId: string;
    candidateName?: string;
    candidateEmail?: string;
    interviewDate?: string;
    interviewTime?: string;
    interviewLink?: string;
    status?: string;
    createdAt?: any;
    interviewCompletedAt?: any;
    interviewResults?: InterviewResults;
    callMetadata?: CallMetadata;
    count?: number;
    rating?: number;
    lastFeedback?: string;
}

export interface InterviewResults {
    greetingMotivation?: string;
    companyIntro?: string;
    valuesGrowth?: string;
    travelCommunication?: string;
    projectExperience?: string;
    dataUsage?: string;
    toolsTechnical?: string;
    processNextStep?: string;
    salaryExpectations?: string;
    overview?: string;
}

export interface CallMetadata {
    callId?: string;
    callDuration?: number;
    callEndedAt?: string;
    callStatus?: string;
    recordingUrl?: string;
}

// API Functions
export const adminApi = {
    login: (user: string, pass: string) =>
        api.post<LoginResponse>('/api/admin/login', { user, pass }),

    firebaseLogin: (idToken: string) =>
        api.post<LoginResponse>('/api/admin/firebase-login', { idToken }),

    logout: async () => {
        // Clear localStorage token for iOS Safari
        setSessionToken(null);
        return api.post<{ ok: boolean }>('/api/admin/logout');
    },

    getRatings: () =>
        api.get<RatingsResponse>('/api/admin/ratings'),

    getCandidates: () =>
        api.get<CandidatesResponse>('/api/admin/candidates'),

    createCandidate: (params: CreateCandidateParams) =>
        api.post<CreateCandidateResponse>('/api/admin/create-candidate', params),
};
